import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Select, SelectProps } from '../../../../../Inputs/Select';
import { MenuProps } from '@mui/material';


export const useMenuClasses = makeStyles<Partial<MenuProps> | undefined>()({
  paper: {
    maxHeight: '240px',
  }
});


export const useTextSelectStyles = makeStyles({ name: 'TextStyleSelect' })({
  root: {
    '&:focus': {
      background: 'transparent',
    },
  },
  select: {
    width: 'fit-content',
    padding: '0px',
    paddingTop: '4px',
    border: 'none',
    boxShadow: 'none',
  },
});


export const useTextRootSelectStyles = makeStyles()({
  root: {
    width: 'auto',
    '& fieldset': {
      display: 'none',
    }
  }
});


export const CustomStartTimeSelect: React.FC<SelectProps & {
  textOnly?: boolean;
}> = (props) => {
  const { classes: menuClasses } = useMenuClasses(props.MenuProps, { props: props?.MenuProps ?? {} });
  const { classes: selectClasses } = useTextSelectStyles();
  const { classes: selectRootClasses } = useTextRootSelectStyles();
  const textOnlyProps = props.textOnly ? {
    selectClasses: selectClasses,
    className: selectRootClasses.root,
  } : {};

  return (
    <Select
      {...props}
      {...textOnlyProps}
      MenuProps={{
        ...props.MenuProps,
        classes: menuClasses,
      }}
    />
  );
};
